function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

// Toggle pane functionality - tab-like behavior with slide transitions
document.querySelectorAll('.toggle-pane-trigger').forEach((trigger) => {
  trigger.addEventListener('click', (event) => {
    event.preventDefault();
    
    const targetId = trigger.getAttribute('data-target');
    const targetElement = document.getElementById(targetId);
    const mainMenu = document.querySelector('.main-menu-container');
    const flexContainer = document.querySelector('.flex-grow-1');
    const scrollContainer = document.querySelector('.overflow-y-auto');
    const bottomActions = document.querySelector('.bottom-actions');
    
    if (targetElement && mainMenu && flexContainer) {
      // Slide out main menu
      mainMenu.classList.add('slide-out');
      
      // Hide all other panes
      if (scrollContainer) {
        scrollContainer.querySelectorAll('.toggle-pane-content').forEach((pane) => {
          if (pane !== targetElement) {
            pane.classList.add('d-none');
            pane.classList.remove('show', 'hide');
          }
        });
      }
      
      // Hide bottom actions
      if (bottomActions) {
        bottomActions.classList.add('d-none');
      }
      
      // Show the target pane with slide animation
      setTimeout(() => {
        targetElement.classList.remove('d-none');
        targetElement.classList.add('show');
        mainMenu.classList.add('d-none');
        mainMenu.classList.remove('slide-out');
      }, 200);
      
      // Update all triggers
      document.querySelectorAll('.toggle-pane-trigger').forEach((t) => {
        t.classList.remove('active');
        t.setAttribute('aria-expanded', 'false');
      });
      
      // Activate current trigger
      trigger.classList.add('active');
      trigger.setAttribute('aria-expanded', 'true');
    }
  });
  
  // Set initial aria-expanded state
  trigger.setAttribute('aria-expanded', 'false');
});

// Back to main menu functionality with slide transitions
document.querySelectorAll('.back-to-main').forEach((backButton) => {
  backButton.addEventListener('click', (event) => {
    event.preventDefault();
    
    const mainMenu = document.querySelector('.main-menu-container');
    const scrollContainer = document.querySelector('.overflow-y-auto');
    const bottomActions = document.querySelector('.bottom-actions');
    
    // Hide all submenu panes with slide animation
    if (scrollContainer) {
      scrollContainer.querySelectorAll('.toggle-pane-content').forEach((pane) => {
        pane.classList.add('hide');
        
        setTimeout(() => {
          pane.classList.add('d-none');
          pane.classList.remove('show', 'hide');
        }, 200);
      });
    }
    
    // Show main menu with slide animation
    if (mainMenu) {
      setTimeout(() => {
        mainMenu.classList.remove('d-none');
        mainMenu.classList.add('slide-in');
        
        setTimeout(() => {
          mainMenu.classList.remove('slide-in');
        }, 400);
      }, 200);
    }
    
    // Show bottom actions
    if (bottomActions) {
      setTimeout(() => {
        bottomActions.classList.remove('d-none');
      }, 200);
    }
    
    // Reset all triggers
    document.querySelectorAll('.toggle-pane-trigger').forEach((trigger) => {
      trigger.classList.remove('active');
      trigger.setAttribute('aria-expanded', 'false');
    });
  });
});

// Megamenu toggle functionality - tab-like behavior with slide transitions
document.querySelectorAll('.megamenu-trigger').forEach((trigger) => {
  trigger.addEventListener('click', (event) => {
    event.preventDefault();
    
    const targetId = trigger.getAttribute('data-target');
    const targetElement = document.getElementById(targetId);
    const mainContent = document.querySelector('.megamenu-main-content');
    const container = document.querySelector('.megamenu-content-container');
    
    if (targetElement && mainContent && container) {
      // Slide out main content
      mainContent.classList.add('slide-out');
      
      // Hide all other panes
      container.querySelectorAll('.megamenu-pane-content').forEach((pane) => {
        if (pane !== targetElement) {
          pane.classList.add('d-none');
          pane.classList.remove('show', 'hide');
        }
      });
      
      // Show the target pane with slide animation
      setTimeout(() => {
        targetElement.classList.remove('d-none');
        targetElement.classList.add('show');
        mainContent.classList.add('d-none');
        mainContent.classList.remove('slide-out');
      }, 200);
      
      // Update all triggers
      document.querySelectorAll('.megamenu-trigger').forEach((t) => {
        t.classList.remove('active');
        t.setAttribute('aria-expanded', 'false');
      });
      
      // Activate current trigger
      trigger.classList.add('active');
      trigger.setAttribute('aria-expanded', 'true');
    }
  });
  
  // Set initial aria-expanded state
  trigger.setAttribute('aria-expanded', 'false');
});

// Megamenu back to main functionality with slide transitions
document.querySelectorAll('.megamenu-back').forEach((backButton) => {
  backButton.addEventListener('click', (event) => {
    event.preventDefault();
    
    const mainContent = document.querySelector('.megamenu-main-content');
    const container = document.querySelector('.megamenu-content-container');
    
    // Hide all submenu panes with slide animation
    if (container) {
      container.querySelectorAll('.megamenu-pane-content').forEach((pane) => {
        pane.classList.add('hide');
        
        setTimeout(() => {
          pane.classList.add('d-none');
          pane.classList.remove('show', 'hide');
        }, 200);
      });
    }
    
    // Show main content with slide animation
    if (mainContent) {
      setTimeout(() => {
        mainContent.classList.remove('d-none');
        mainContent.classList.add('slide-in');
        
        setTimeout(() => {
          mainContent.classList.remove('slide-in');
        }, 400);
      }, 200);
    }
    
    // Reset all triggers
    document.querySelectorAll('.megamenu-trigger').forEach((trigger) => {
      trigger.classList.remove('active');
      trigger.setAttribute('aria-expanded', 'false');
    });
  });
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};